import { render, staticRenderFns } from "./SubscribeMessageForm.vue?vue&type=template&id=0b289816&"
import script from "./SubscribeMessageForm.vue?vue&type=script&lang=js&"
export * from "./SubscribeMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports